export default (text) => text.replace(/^\//, '');